import React from 'react'
import { type Role } from 'services'
import { RoleSelect } from 'components'
import { US_COMMITTEE_ROLES } from 'utils'

export interface CommitteeTypeFiltersProps {
  value: Role | null
  updateCommitteeType: (type: Role | null) => void
  showSubs?: boolean
  disabled: boolean
  label?: string
  branchId?: number
}

export const CommitteeTypeSelect: React.FC<CommitteeTypeFiltersProps> = ({ value, updateCommitteeType, showSubs = false, disabled, label = 'Committee Type', branchId }) => {
  const getCommitteeRoles = (roles: Role[]): Role[] => {
    let committeeRoles = roles.filter((role: Role) => Object.values(US_COMMITTEE_ROLES).includes(role.id))
    if (!showSubs) {
      committeeRoles = committeeRoles.filter(role => role.id !== US_COMMITTEE_ROLES.FED_SUBCOMMITTEE && role.id !== US_COMMITTEE_ROLES.STATE_SUBCOMMITTEE)
    }
    if (branchId != null) {
      committeeRoles = committeeRoles.filter(role => role.branch.id === branchId)
    }
    return committeeRoles
  }

  return (
    <RoleSelect value={value} updateRole={updateCommitteeType} getRoleFilter={getCommitteeRoles} disabled={disabled} label={label}
    />
  )
}
